import { NgModule } from '@angular/core';

import { ControlErrorFactoryService } from '@svg-frontends/error/services/control-error-factory.service';

@NgModule({
	providers: [{ provide: ControlErrorFactoryService, useClass: ControlErrorFactoryService }],
})
export class ErrorMessageModule {}
